import { beginLightning, endLightning, store, ActionType } from 'owa-lightning-core-v2';

/**
 * Lightning properties
 */
export interface LightningProps {
    lid: string;
    when: (lightup: () => void) => void;
    series?: string[];
}

export function lightable<T extends Function>(target: T): T {
    let render = target.prototype.render;

    target.prototype.render = function() {
        return shouldShowLightningItem(this.props.lid) ? render.call(this, arguments) : null;
    };

    let onMount = target.prototype.componentDidMount;

    target.prototype.componentDidMount = function() {
        if (onMount) {
            onMount.call(this, arguments);
        }

        beginLightning.importAndExecute(this.props.lid, this.props.when, this.props.series);
    };

    let onUnmount = target.prototype.componentWillUnmount;

    target.prototype.componentWillUnmount = function() {
        if (onUnmount) {
            onUnmount.call(this, arguments);
        }

        endLightning.importAndExecute(this.props.lid);
    };

    return target;
}

export function lighted(lid: string, actionType?: ActionType): void {
    endLightning.importAndExecute(lid, actionType);
}

export function shouldShowLightningItem(lid: string) {
    if (store.unseenItems) {
        let viewState = store.unseenItems.get(lid);

        if (viewState?.visible) {
            return true;
        }
    }
    return false;
}
